import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { axiosInstance } from '../../api';
import { endpoints } from '../../api/endpoints';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { senderAddress } from '../../configs';
import { useSelector } from 'react-redux';
import notify from '../../utils/notify';
import Loader from '../loader/Loader';
import Web3 from 'web3';

const schema = yup.object({
    nftPrice: yup.string().required('Please enter nft Price'),
});

const SellNft = ({ nftAddress, nftId }) => {
    const userId = useSelector((state) => state?.userData?.userData._id);
    const nftData = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [addressIsValid, setAddressIsValid] = useState(true);

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    const submitHandler = (submittedData) => {
        let payload = {
            ...nftData,
            nftPrice: submittedData.nftPrice,
        };
        axiosInstance
            .post(endpoints.putOnSale, payload)
            .then((res) => {
                navigate(0);
            })
            .catch((error) => {
                console.erro(error);
            });
    };

    const withdrawNftHandler = (event) => {
        event.preventDefault();
        const recieverAddress = event.target.revieverAddress.value;
        if (recieverAddress.length) {
            const isValid = Web3.utils.isAddress(recieverAddress);
            if (!isValid || senderAddress === recieverAddress) {
                setAddressIsValid(false);
            } else {
                setIsLoading(true);
                const payload = {
                    nftAddress: nftAddress,
                    userId: userId,
                    senderAddress: senderAddress,
                    recieverAddress: recieverAddress,
                    nftId: nftId,
                };
                axiosInstance
                    .post(endpoints.withdrawNft, payload)
                    .then((res) => {
                        notify(res.data.responseMessage);
                        navigate('/profile');
                        setIsLoading(false);
                    })
                    .catch((error) => {
                        notify(error.response.data.Message);
                        setIsLoading(false);
                    });
            }
        } else {
            setAddressIsValid(false);
        }
    };

    return (
        <>
            <div className="mb-2">
                <form onSubmit={handleSubmit(submitHandler)}>
                    <div className="d-flex sale-wrapper">
                        <div className="input-wrap-sale">
                            <input
                                {...register('nftPrice')}
                                type="number"
                                step="0.000000000000000001"
                                placeholder={'NFT price'}
                                className="form-control h-100"
                            />
                            {errors.nftPrice && <span className="error-msg">{errors.nftPrice.message}</span>}
                        </div>
                        <button type="submit" style={{ minWidth: '145px' }} className="btn-main">
                            Put on sale
                        </button>
                    </div>
                </form>
            </div>
            <div className="">
                <form onSubmit={withdrawNftHandler}>
                    <div className="d-flex sale-wrapper">
                        <div className="input-wrap-sale">
                            <input type="text" name={'revieverAddress'} placeholder={'Reciever Address'} className="form-control h-100" />
                            {!addressIsValid && <span className="error-msg">Please enter a valid address</span>}
                        </div>
                        <button type="submit" style={{ minWidth: '145px' }} className="btn-main">
                            Withdraw NFT
                        </button>
                    </div>
                </form>
            </div>
            {isLoading && <Loader />}
        </>
    );
};

export default SellNft;
